import { useTranslation } from 'next-i18next';
import type { IOffer } from '@bridebook/models/source/models/Suppliers/Offers.types';
import { Box, Well } from '@bridebook/ui';
import { OfferTypes } from '@bridebook/web/lib/offers/constants';
import { getTileConfigV2 } from '@bridebook/web/lib/offers/data/tile-config-v2';
import { getTimeLeft } from '@bridebook/web/lib/offers/utils';
import styles from './index.style';
import { Tag } from '@bridebook/aura';
import { Clock } from '@bridebook/aura/src/icons';

interface IProps {
  type: OfferTypes;
  offer: IOffer;
  currencySymbol: string;
  onTileClick?: (offer: IOffer, type: OfferTypes) => void;
}

const OfferTile = ({ type, offer, currencySymbol, onTileClick }: IProps) => {
  const { t } = useTranslation('offers');

  const { tag, title, subtitle, wellTheme, tagTheme, timeLeftTagTheme, expiration } =
    getTileConfigV2(type, offer, currencySymbol);

  const timeLeft = expiration ? getTimeLeft(expiration) : null;

  return (
    <Box style={styles.wrapper} onClick={() => onTileClick?.(offer, type)}>
      <Well slim theme={wellTheme} withChevron fitContainer>
        <Box style={styles.tagsWrapper}>
          <Tag theme={tagTheme}>{tag}</Tag>
          {!!timeLeft && (
            <Tag theme={timeLeftTagTheme} iconLeft={Clock}>
              {t('timeLeft', {
                timeLeft,
              })}
            </Tag>
          )}
        </Box>
        <Box style={styles.title}>{title}</Box>
        <Box style={styles.subtitle}>{subtitle}</Box>
      </Well>
    </Box>
  );
};

export default OfferTile;
